/// <summary>
/// 部署設定継承情報(通信用)
/// ★★★メンバ変数は名称を含め「CtlSvr_Cloud/Models/Setting/DependingDivisionData.cs」と同じ構成である必要があります★★★
/// </summary>
export interface DependingDivisionDataIF
{
    divisionId: number;
    dependDivisionId: number;
}

/// <summary>
/// 部署設定継承情報(UI用に扱いやすいように変換)
/// </summary>
export class DependingDivisionData {
    public mapDependingDivision: Map<number, number>;   // 継承先部署情報（first:部署ID, second:継承先）

    /// <summary>
    /// コンストラクタ
    /// </summary>
    constructor() {
        this.mapDependingDivision = new Map<number, number>();
    }

    /// <summary>
    /// データベースの情報をデータクラスに変換します
    /// @param[in] arDependingList   : 部署設定継承情報(通信用)
    /// </summary>
    public Load(arDependingList: Array<DependingDivisionDataIF>): void {
        this.mapDependingDivision = new Map<number, number>();

        arDependingList.forEach(x => {
            this.mapDependingDivision.set(x.divisionId, x.dependDivisionId);
        });
    }
}